// Mirrors Domain/Enums/OfferImageHeights.cs. Images always take the full width of the PDF
// content area; the height is a fraction of the content area between the header and footer.
const CONTENT_WIDTH_MM = 193;
const CONTENT_HEIGHT_MM = 240;
const SPACING_MM = 2;

const IMAGE_HEIGHTS: { value: string; pageFraction: number }[] = [
  { value: 'full-page', pageFraction: 1 },
  { value: 'half-page', pageFraction: 2 },
  { value: 'third-page', pageFraction: 3 },
  { value: 'quarter-page', pageFraction: 4 },
  { value: 'sixth-page', pageFraction: 6 },
  { value: 'eighth-page', pageFraction: 8 },
];

const DEFAULT_IMAGE_HEIGHT = 'quarter-page';

const getImageHeightMm = (height: string): number => {
  const pageFraction =
    IMAGE_HEIGHTS.find((option) => option.value === height)?.pageFraction ?? 4;

  return Math.floor(CONTENT_HEIGHT_MM / pageFraction) - SPACING_MM;
};

export {
  CONTENT_WIDTH_MM,
  DEFAULT_IMAGE_HEIGHT,
  IMAGE_HEIGHTS,
  getImageHeightMm,
};
